import React, { useState } from 'react';
import { supabase } from '../../supabaseClient'; // Adjust path to your Supabase client

const SearchButton = ({ onSearchResults }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;

    setLoading(true);

    // Querying the indexed 'name' column
    const { data, error } = await supabase
      .from('videos')
      .select('*')
      .ilike('name', `%${searchTerm}%`); // Uses the trigram index created above

    setLoading(false);

    if (error) {
      console.error('Search error:', error);
      return;
    }

    // Pass results up to parent component
    if (onSearchResults) {
      onSearchResults(data);
    }
  };

  return (
    <form onSubmit={handleSearch} className="flex items-center gap-2 mr-6">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search videos..."
        className="px-3 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <button 
        type="submit" 
        disabled={loading}
        className="text-gray-600 hover:text-black transition-colors"
        aria-label="Search"
      >
        <i className={`fa-sharp fa-solid ${loading ? 'fa-spinner fa-spin' : 'fa-magnifying-glass'} text-lg`}></i>
      </button>
    </form>
  );
};

export default SearchButton;
